import accountAPI from '@/apis/accounts/accountAPI';
import nationApi from '@/apis/national/index';
import commonFn from '@/commons/commonFunction';
import webSocket from '@/sockets/socket';
export default {
  async getRoles(context) {
    try {
      let res = await accountAPI.getAllRole();
      if (res && res.Data) {
        if (res.Data) {
          context.commit('updateRoles', res.Data);
        }
      }
      return res;
    } catch (ex) {
      commonFn.errorLogging('Lỗi lấy thông tin roles:: ', ex);
    }
  },
  async getNations(context) {
    try {
      let res = await accountAPI.getAllNation();
      if (res && res.Data) {
        if (res.Data) {
          context.commit('updateNationsGL', res.Data);
        }
      }
      return res;
    } catch (ex) {
      commonFn.errorLogging('Lỗi lấy thông tin nation:: ', ex);
    }
  },

  async getNationsEmployee(context) {
    try {
      let res = await nationApi.getNationalEmployee();
      if (res && res.Data) {
        if (res.Data) {
          context.commit('updateNationsEmployee', res.Data);
        }
      }
      return res;
    } catch (error) {
      commonFn.errorLogging('Lỗi lấy thông tin nation employee:: ', error);
    }
  },

  async getAllPartners(context) {
    try {
      let res = await accountAPI.getAllPartner();
      if (res && res.Data) {
        if (res.Data) {
          context.commit('updatePartners', res.Data);
        }
      }
      return res;
    } catch (error) {
      commonFn.errorLogging('Lỗi lấy thông tin partner:: ', error);
    }
  },
};
